<!--
  The account menu (`UserMenu`) in a temporary drawer, opened from the rail's avatar. Mounted from
  600 px only: on a phone the same menu lives in Plus's sheet (`MoreSheet`). Every attribute and
  listener the layout sets goes to the menu.
-->
<template>
  <v-navigation-drawer
    v-model="drawerOpen"
    :location="location"
    :width="340"
    temporary
    class="user-drawer"
  >
    <UserMenu v-bind="$attrs" @close="drawerOpen = false">
      <template #notifications="scope">
        <slot name="notifications" v-bind="scope" />
      </template>
    </UserMenu>
  </v-navigation-drawer>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useLayoutStore } from '../../stores'
import UserMenu from './UserMenu.vue'

defineOptions({ inheritAttrs: false })

withDefaults(defineProps<{ location?: 'left' | 'right' | 'top' | 'bottom' }>(), {
  location: 'left',
})

const layoutStore = useLayoutStore()

const drawerOpen = computed({
  get: () => layoutStore.userDrawerOpen,
  set: (value) => {
    if (value) {
      layoutStore.openUserDrawer()
    } else {
      layoutStore.closeUserDrawer()
    }
  },
})
</script>

<style lang="scss">
.user-drawer {
  .v-navigation-drawer__content {
    overflow: hidden;
    background: rgba(var(--v-theme-surface), 0.95);
    backdrop-filter: blur(10px);
  }
}
</style>
